import React from 'react';
import { Hero } from '../components/Hero';
import { WhyUs } from '../components/WhyUs';
import { Services } from '../components/Services';
import { HowItWorks } from '../components/HowItWorks';
import { FAQ } from '../components/FAQ';
import { Reviews } from '../components/Reviews';
import { CtaBanner } from '../components/CtaBanner';
export function Home() {
  return <main data-id="element-2245">
      <div className="dark" data-id="element-2246">
        <Hero data-id="element-2247" />
      </div>
      <WhyUs data-id="element-2248" />
      <Services data-id="element-2249" />
      <HowItWorks data-id="element-2250" />
      <FAQ data-id="element-2251" />
      <Reviews data-id="element-2252" />
      <CtaBanner data-id="element-2253" />
    </main>;
}